<template>
  <div>
    <div
      v-if="!feedbkForm"
      style="height: 100dvh"
      class="bluebtn position-relative"
    >
      <!-- <mob-header/> -->
      <div v-if="scheduleInterviewPage" class="h-100">
        <div class="page-head-mob p-3">
          <div v-if="schedulePage == true">
            <div>
              <img
                @click="goBack()"
                class="mr-3 mb-1 pointer"
                src="../../assets/panelLog/mob-design/bck-arr-mob-head.svg"
                alt=""
              />Scheduled Interviews
            </div>
          </div>
          <div v-if="feedbackPage == true">
            <div>
              <img
                @click="goBack()"
                class="mr-3 mb-1 pointer"
                src="../../assets/panelLog/mob-design/bck-arr-mob-head.svg"
                alt=""
              />Feedback Provided
            </div>
          </div>
        </div>
        <div
          :class="showFilter || showRounds ? 'blur-class' : ''"
          class="mobile-body"
          style="height: 91%"
        >
          <div class="mob-pan-body-nh py-2 px-1">
            <div class="d-flex align-items-center">
              <div
                class="mt-2 mb-2 position-relative mx-2 mob-search-pan"
                style="width: 85%"
              >
                <b-form-input
                  class=""
                  v-model.trim="searchname"
                  debounce="500"
                  @update="searchPanel"
                  type="search"
                  placeholder="Search Candidates"
                >
                </b-form-input>
                <img
                  style="position: absolute; top: 8px; left: 13px"
                  src="../../assets/panelMob/magni.svg"
                  alt=""
                />
              </div>
              <div class="position-relative">
                <img
                  @click="showFilterDiv"
                  src="../../assets/panelLog/mob-design/wfil-bbg.svg"
                  alt=""
                />
                <div
                  class="mb-3 pointer"
                  style="position: absolute; top: -4px; right: 3px"
                  v-if="filtercount != 0"
                >
                  <img
                    style="width: 7px; height: 7px"
                    src="../../assets/panelist/fil_selected.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <PanelMobileShimmer v-if="LoaderStatus" />
            <div
              v-else-if="
                allpaneldata.length == 0 &&
                searchname == '' &&
                filtercount == 0 &&
                $route.query.status == 'scheduletab' &&
                !showLoader
              "
              class="
                h-100
                d-flex
                justify-content-center
                align-items-center
                flex-column
              "
            >
              <div class="">
                <img src="../../assets/panelLog/mob-design/noscfp-data.svg" />
              </div>
              <div class="noscfp-data-txt">
                There are no interviews scheduled with you.
              </div>
            </div>
            <div
              v-else-if="
                allpaneldata.length == 0 &&
                searchname == '' &&
                filtercount == 0 &&
                $route.query.status == 'feedbacktab' &&
                !showLoader
              "
              class="
                h-100
                d-flex
                justify-content-center
                align-items-center
                flex-column
              "
            >
              <div class="">
                <img src="../../assets/panelLog/mob-design/noscfp-data.svg" />
              </div>
              <div class="noscfp-data-txt">There is no feedback provided.</div>
            </div>
            <div
              v-else-if="
                allpaneldata.length == 0 && searchname != '' && filtercount == 0
              "
            >
              <div class="img-pos-nodata d-flex justify-content-center mr-4">
                <img
                  src="../../assets/panelLog/mob-design/nosearch-scfp-dat.svg"
                />
              </div>
              <div class="noscfp-data-txt mt-3 mr-3 text-break">
                No matching results for '{{ searchname }}'.
              </div>
            </div>
            <div v-else-if="allpaneldata.length == 0 && filtercount != 0">
              <div class="img-pos-nodata d-flex justify-content-center mr-4">
                <img
                  src="../../assets/panelLog/mob-design/nofilter-scfp-dat.svg"
                />
              </div>
              <div class="noscfp-data-txt mt-3 mr-3">No records found.</div>
            </div>

            <div v-else class="schedule-overflow-nh" @scroll="onScroll">
              <div
                v-for="(cand, index) in allpaneldata"
                :key="index"
                class="m-1 panlog-mob-card px-3 py-2 pointer"
                :class="index > 0 ? 'mt-3' : ''"
                :style="
                  $route.query.status == 'feedbacktab'
                    ? 'height:108px'
                    : 'height:143px'
                "
                @click.stop="particularCandidate(cand)"
              >
                <div class="pan-card-txt text-truncate">
                  {{ cand.candidate.name }}
                </div>
                <div class="pan-card-txt text-truncate">
                  {{ cand.candidate.email }}
                </div>
                <div class="d-flex justify-content-between">
                  <div class="pan-card-txt text-truncate mb-1">
                    {{ cand.candidate.phoneNumber }}
                  </div>
                  <div>
                    <img
                      src="../../assets/panelLog/mob-design/mob-side-arrow.svg"
                    />
                  </div>
                </div>
                <div class="d-flex w-100">
                  <div class="w-70">
                    <div class="pan-card-head">Job Name</div>
                    <div class="pan-card-txt text-truncate pr-1">
                      {{ cand.jobName }}
                    </div>
                  </div>
                  <div class="w-30">
                    <div class="pan-card-head">Rounds</div>
                    <div class="pan-card-txt">
                      {{ cand.interviewRound.roundOfrounds }}
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between mt-2 w-100"
                  v-if="schedulePage"
                >
                  <div @click.stop="navigateToLink(cand)" class="addpan w-50">
                    <b-button class="btn-txt-mob btn-mob-size w-100">
                      Join Meeting
                    </b-button>
                  </div>
                  <div class="addpan w-50">
                    <b-button
                      @click.stop="getfeedbackforms(cand)"
                      class="btn-txt-mob btn-mob-size w-100 ml-2"
                    >
                      Give Feedback
                    </b-button>
                  </div>
                </div>
              </div>

              <b-overlay
                class="mt-4"
                :show="showLoader"
                rounded="sm"
              ></b-overlay>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        hide-footer
        hide-header
        id="panelfiltermodal"
        modal-class="bottom-modal"
        v-model="showFilter"
        no-close-on-backdrop
        @hidden="showFilter = false"
      >
        <template v-if="!showRounds">
          <div class="text-center filter-box-head">Filters</div>
          <div>
            <div class="filter-in-mob" @click.stop="">
              <label class="sub-head-mob-fil">Job Name:</label>
              <b-form-input
                class="text-truncate"
                id="input-1"
                placeholder="Enter"
                v-model="filter.jobName"
              >
              </b-form-input>
            </div>
            <div class="mt-2 mb-2 tags-with-addBtn tags-with-addBtn-mob">
              <label class="sub-head-mob-fil">Skills:</label>
              <b-form-tags
                class="text-truncate"
                id="input-1"
                :tag-validator="tagValidatorskill"
                placeholder="Enter"
                v-model="filter.skills"
                remove-on-delete
              ></b-form-tags>
              <span class="panelskills-text ml-1">
                Press enter to separate Skills
              </span>
            </div>
            <div class="mt-1 mb-2 d-flex justify-content-between">
              <div class="filter-in-mob position-relative w-100">
                <label class="sub-head-mob-fil">Rounds:</label>
                <b-form-input
                  class="text-truncate"
                  id="input-1"
                  placeholder="Select"
                  v-model="arrayAsString"
                  @click="showRounds = true"
                >
                </b-form-input>
                <img
                  class="dpd-arr-pos"
                  style="height: 8px; width: 12px"
                  src="../../assets/img/accessconnew/blueDownArrow.svg"
                />
              </div>
            </div>
          </div>
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              bluebtn
              mt-3
            "
          >
            <b-button class="acs-cancelBtn-filter" @click="showFilter = false">
              Cancel
            </b-button>

            <div class="d-flex">
              <b-button
                class="acs-cancelBtn-filter mr-2"
                :disabled="filtercount == 0"
                @click="clearfilter()"
              >
                Reset
              </b-button>
              <b-button
                class="pointer acs-cancelBtn-filter"
                :disabled="
                  filter.jobName == '' &&
                  filter.skills.length == 0 &&
                  filter.round.length == 0
                "
                @click="applyFilterCard()"
              >
                Apply
              </b-button>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="d-flex justify-content-between w-55">
            <div @click="showRounds = false">
              <img src="../../assets/panelLog/mob-design/filter-bck-arr.svg" />
            </div>
            <div class="filter-box-head">Rounds</div>
          </div>
          <div class="p-2 d-flex flex-wrap m-1 mt-2">
            <div
              @click="selectRound(i)"
              class="rounds-bubbles flex-class m-1"
              :class="index.includes(i) ? 'selected-bubble' : 'rounds-bubbles'"
              v-for="(item, i) in interviewRounds"
              :key="i"
            >
              {{ item.text }}
            </div>
          </div>
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              mt-3
              bluebtn
            "
          >
            <b-button class="acs-cancelBtn-filter" @click="showFilterDiv">
              Cancel
            </b-button>

            <div class="d-flex">
              <b-button
                class="acs-cancelBtn-filter mr-2"
                :disabled="filtercount == 0"
                @click="clearfilter()"
              >
                Reset
              </b-button>
              <b-button
                class="pointer acs-cancelBtn-filter"
                :disabled="
                  filter.jobName == '' &&
                  filter.skills.length == 0 &&
                  filter.round.length == 0
                "
                @click="applyFilterCard()"
              >
                Apply
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>
      <!-- <div class="filter-box-mob p-3 px-4" v-if="showFilter">
      
        </div> -->
      <!-- <transition name="slidemob">
        <div class="rounds-box p-3" v-if="showRounds">
          <div class="d-flex justify-content-between w-55">
            <div @click="showFilterDiv">
              <img src="../../assets/panelLog/mob-design/filter-bck-arr.svg" />
            </div>
            <div class="filter-box-head">Rounds</div>
          </div>
          <div class="p-2 d-flex flex-wrap m-1 mt-2">
            <div
              @click="selectRound(i)"
              class="rounds-bubbles flex-class m-1"
              :class="index.includes(i) ? 'selected-bubble' : 'rounds-bubbles'"
              v-for="(item, i) in interviewRounds"
              :key="i"
            >
              {{ item.text }}
            </div>
          </div>
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              mt-3
              bluebtn
            "
          >
            <b-button class="acs-cancelBtn-filter" @click="showFilterDiv">
              Cancel
            </b-button>

            <div class="d-flex">
              <b-button
                class="acs-cancelBtn-filter mr-2"
                :disabled="filtercount == 0"
                @click="clearfilter()"
              >
                Reset
              </b-button>
              <b-button
                class="pointer acs-cancelBtn-filter"
                :disabled="
                  filter.jobName == '' &&
                  filter.skills.length == 0 &&
                  filter.round.length == 0
                "
                @click="applyFilterCard()"
              >
                Apply
              </b-button>
            </div>
          </div>
        </div>
      </transition> -->
    </div>
    <template v-else>
      <GiveFeedbackForm
        :viewfeedback="viewfeedback"
        :feedback="feedback"
        :panelName="panelName"
        :evalDate="evalDate"
        :interviewCandidate="interviewCandidate"
        :feedbackform="feedbackform"
        :allpaneldata="allpaneldata"
        @goBack="openDivs"
        :candidate="singleCandidateData"
      />
    </template>
  </div>
</template>
<script>
import PanelMobileShimmer from "../../components/fixedcomponents/PanelMobileShimmer.vue";
import mobilePanelMixins from "../../views/panelLogin/mobilePanelMixins.js";
//  import mobHeader from "../../components/fixedcomponents/MobHeader.vue";
import { history } from "../../controllers/panelLogin/asynchronous.js";
import GiveFeedbackForm from "../../views/panelLogin/GiveFeedbackForm";
import { getfeedbackforms } from "../../utils/apiFunctions";
import { mapGetters } from "vuex";

export default {
  components: {
    GiveFeedbackForm,
    PanelMobileShimmer,
  },
  data() {
    return {
      singleCandidateData: {},
      feedbkForm: false,
      interviewCandidate: "",
      evalDate: "",
      panelName: "",
      filtercount: 0,
      loopvar: 2,
      LoaderStatus: false,
      payload: {},
      filter: {
        jobName: "",
        skills: [],
        round: [],
      },
      index: [],
      interviewRounds: [],
      viewfeedback: false,
      feedback: {
        recOption: null,
      },
      timer: null,
      searchname: "",
      showGiveFeebackButton: false,
      showFilter: false,
      particularCand: false,
      scheduleInterviewPage: false,
      schedulePage: false,
      feedbackPage: false,
      mainPage: false,
      showRounds: false,
      currentPage: 1,
      pageCount: 10,
      feedbackValue: "false",
      statusValue: "createdAt",
      sortOrder: false,
      totalScheduledInterviews: null,
      showLoader: false,
      totalFeedbackProvided: null,
      allpaneldata: [],
      total: null,
      pageEnd: null,
      feedbackform: {},
    };
  },
  mixins: [mobilePanelMixins],

  props: {
    isLaptop: Boolean,
  },

  created() {
    this.scheduleInterviewPage = true;
    this.LoaderStatus = true;
    if (this.$route.query.status == "feedbacktab") {
      this.getAllPanelCandidate("true");
      this.feedbackPage = true;
    } else if (this.$route.query.status == "scheduletab") {
      this.getAllPanelCandidate("false");
      this.schedulePage = true;
    } else {
      this.schedulePage = true;
      this.getAllPanelCandidate("false");
    }
  },
  computed: {
    arrayAsString() {
      const sortedRounds = this.filter.round
        .filter((round) => round !== "F")
        .sort((a, b) => a - b);
      if (this.filter.round.includes("F")) {
        sortedRounds.push("F");
      }
      return sortedRounds.join(", ");
    },
    ...mapGetters("userVUEX", {
      userInfo: "getRoleValues",
    }),
  },
  methods: {
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

      const day = days[date.getDay()];
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      const hour = date.getHours();
      const minute = String(date.getMinutes()).padStart(2, "0");
      const ampm = hour >= 12 ? "PM" : "AM";
      const formattedHour = hour % 12 || 12;

      return `${formattedHour}:${minute} ${ampm} ${day}, ${month} ${date.getDate()}, ${year}`;
    },
    openDivs(value) {
      this.feedbkForm = value;
    },
    selectRound(i) {
      if (!this.index.includes(i)) {
        this.index.push(i);
        this.filter.round.push(this.interviewRounds[i].value);
      } else {
        this.index.splice(this.index.indexOf(i), 1);
        this.filter.round.splice(
          this.filter.round.indexOf(this.interviewRounds[i].value),
          1
        );
      }
    },
    async getfeedbackforms(candidate) {
      this.singleCandidateData = candidate;
      this.interviewCandidate = candidate.candidate.name;
      this.panelName = this.userInfo.username;
      this.evalDate = candidate.startTimeFormatted;
      await history(candidate, this);
      getfeedbackforms(1, candidate.interviewRound.feedbackFormID).then(
        (res) => {
          if (res.status == 200) {
            const { data } = res.data;
            if (data) {
              if (candidate.interviewRound.id == "F") {
                this.feedbackform = data;
              } else {
                this.feedbackform = data;
              }
            }
          }
        }
      );
      this.feedback.recOption = null;
      this.feedbkForm = true;

      this.$store.commit("panelVUEX/setSelectedCandidate", candidate);
    },

    tagValidatorskill(tag) {
      let skill_list = this.filter.skills.map((s) => s.toLowerCase());
      return !skill_list.includes(tag.toLowerCase());
    },
    clearfilter() {
      this.filter.jobName = "";
      this.filter.skills = [];
      this.selectedValue = "";
      this.filter.round = [];
      this.index = [];
      this.showFilter = false;
      this.showRounds = false;
      this.LoaderStatus = true;
      if (this.filtercount != 0) {
        if (this.$route.query.status == "feedbacktab") {
          this.getAllPanelCandidate("true");
        } else if (this.$route.query.status == "scheduletab") {
          this.getAllPanelCandidate("false");
        } else {
          this.getAllPanelCandidate("false");
        }
      }
      this.filtercount = 0;
    },
    applyFilterCard() {
      this.showFilter = false;
      this.showRounds = false;
      this.currentPage = 1;
      this.filtercount = 0;
      this.LoaderStatus = true;
      if (
        this.filter.jobName != "" ||
        this.filter.skills.length != 0 ||
        this.filter.round.length != 0
      ) {
        this.filtercount++;
      }
      if (this.$route.query.status == "feedbacktab") {
        this.getAllPanelCandidate("true");
      } else if (this.$route.query.status == "scheduletab") {
        this.getAllPanelCandidate("false");
      } else {
        this.getAllPanelCandidate("false");
      }
      // this.getAllPanelCandidate();
    },
    searchPanel() {
      this.currentPage = 1;
      this.LoaderStatus = true;
      if (this.$route.query.status == "feedbacktab") {
        this.getAllPanelCandidate("true");
      } else if (this.$route.query.status == "scheduletab") {
        this.getAllPanelCandidate("false");
      } else {
        this.getAllPanelCandidate("false");
      }
    },
    particularCandidate(cand) {
      if (cand.feedback) {
        this.$router.push({
          name: "CandidateDetails",
          query: {
            status: "feedbacktab",
          },
        });
      } else {
        this.$router.push({
          name: "CandidateDetails",
        });
      }

      this.$store.commit("panelVUEX/setSelectedCandidate", cand);
    },

    feedbackProvided() {
      this.searchname = "";
      this.payload.feedback = "";
      this.currentPage = 1;
      this.scheduleInterviewPage = true;
      this.feedbackPage = true;
      this.schedulePage = false;
      this.LoaderStatus = true;
      this.allpaneldata = [];
      this.getAllPanelCandidate("true");
    },
    schedule() {
      this.searchname = "";
      this.payload.feedback = "";
      this.currentPage = 1;

      this.scheduleInterviewPage = true;
      this.schedulePage = true;
      this.feedbackPage = false;
      this.LoaderStatus = true;
      this.allpaneldata = [];
      this.getAllPanelCandidate("false");
    },
    navigateToLink(data) {
      if (data?.interviewRound?.roomId) {
        this.errorModal("Sorry, this interview cannot be taken from mobile");
      } else if (data?.meetingLink) {
        window.open(data.meetingLink, "_blank");
      }
    },
    goBack() {
      this.$router.push({
        name: "PanelLogin",
      });
      this.LoaderStatus = true;
      this.searchname = "";
      this.filter.jobName = "";
      this.filter.skills = [];
      this.filter.round = [];
      this.feedback.recOption = null;
      this.$forceUpdate();
      this.getAllPanelCandidate("true");
      this.getAllPanelCandidate("false");

      this.currentPage = 0;
    },
    showFilterDiv() {
      this.showFilter = !this.showFilter;
      this.showRounds = false;
    },
    showRoundsDiv() {
      this.showFilter = false;
      this.showRounds = true;
    },
  },
};
</script>

<style>
.mobile-feedback-shimmer {
  color: #000;
}
.panlg-overflow {
  overflow: auto;
  border-radius: 5px;
  border: 1px solid #ebebeb;
  background: #fff;
}

.h-95 {
  height: 95%;
}

.panlg-footer {
  height: 9%;
  border-radius: 5px;
  background: #fff;
  border-top: 1px solid #ebebeb;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.panlg-blueTxt {
  color: #257cff;
  font-size: 12px;
  font-weight: 400;
}

.panlg-blueBack {
  border-radius: 5px;
  background: rgba(242, 242, 242, 0.98);
  padding: 10px;
}

.panlg-whiteCard {
  border-radius: 5px;
  border: 1px solid #ebebeb;
  background: #fff;
}

.panlg-greentxt {
  color: #038e00;
  font-size: 12px;
  font-weight: 500;
}

.panlg-redtxt {
  color: #d90606;
  font-size: 12px;
  font-weight: 500;
}

.panlg-yellowtxt {
  color: #ffc145;
  font-size: 12px;
  font-weight: 500;
}

.panlg-greytxt {
  color: #6d6d6d;
  font-size: 12px;
  font-weight: 400;
}

.mob-plainbtn {
  color: #72738e;

  font-size: 14px;

  font-weight: 500;

  background-color: transparent;
}

.mob-greybtn {
  border-radius: 3px;
  background: #72738e;
  color: #fff;

  font-size: 13px;

  font-weight: 500;
}

.mobile-header {
  background: #fff;
  box-shadow: 0px 4px 20px 0px #000;
  height: 8%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mobile-body {
  height: 92%;
  background: #e9ecef;
  padding: 15px;
}

.small-txt-head {
  color: #72738e;
  font-size: 18px;
  font-weight: 500;
}

.big-txt-head {
  color: #72738e;
  font-size: 21px;
  font-weight: 600;
}

.panlg-card {
  border-radius: 5px;
  border: 1px solid #ebebeb;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.schedule-overflow {
  height: 85%;
  overflow: auto;
}

.w-30 {
  width: 30%;
}

.w-20 {
  width: 20%;
}

.panel-nofeedback-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #696969;
}
.mobile-feedbk-round-head-jd {
  font-weight: 600;
  font-size: 11px;
  color: #545454;
}
.panlg-input {
  border-radius: 3px;
  border: 0.5px solid #c4c4c4;
  background: #fff;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2) inset;
  padding: 5px 43px 7px 27px;
}
/* Transition classes */
.slidemob-enter-active,
.slidemob-leave-active {
  transition: transform 1s ease;
}

.slidemob-enter {
  transform: translateY(100%);
}

.slidemob-leave-to {
  transform: translateY(100%);
}

.sub-head-mob-fil {
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 12px;
  color: #344054;
}
.filter-in-mob .form-control {
  height: 30px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #667085;
}

.tags-with-addBtn-mob .form-control {
  height: 35px !important;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #667085;
}
.hint-txt-mob {
  position: absolute;
  left: 19px;
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 10px;
  color: #7a7a7a;
}
.rounds-box {
  position: absolute;
  bottom: 0%;
  left: 0;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px -5.5px 10px rgba(40, 41, 61, 0.15);
  border-radius: 10px 10px 0px 0px;
}
.blur-class {
  filter: blur(2px);
  transition: filter 0.3s ease;
  pointer-events: none;
}
.bottom-modal .modal-dialog {
  position: fixed;
  bottom: 0;
  margin: 0;
  max-width: 100%;
  width: 100%;
  transition: bottom 0.5s ease;
}
</style>
